import { Outlet } from "@tanstack/react-router";

import { LanguageSelector } from "@/components/shared/LanguageSelector";
import { Image } from "@/components/ui/Image";

import logoImage from "@/assets/shared/logo-horizontal.svg";

export const ShareAccessShell = () => {
  return (
    <div className="h-screen bg-[#FBFAF8]">
      <div className="h-screen max-w-[1920px] mx-auto flex flex-col">
        <header className="min-h-20 border-b border-neutral-100 flex items-center justify-between px-6 bg-[#FBFAF8]">
          <Image
            src={logoImage}
            alt="MiMIAT Health"
            containerClassName="w-60"
            className="w-[50%] m-auto"
          />

          <LanguageSelector />
        </header>

        <main className="min-h-0 flex-1 p-8 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
